import { Directive, HostBinding, HostListener, inject, input, output } from '@angular/core';
import { SnackbarService } from '../services/util/snackbar.service';

@Directive({
  selector: '[outlawDragAndDrop]',
  standalone: true,
})
export class DragAndDropDirective {
  #snackbar = inject(SnackbarService);

  allowedTypes = input<string[]>([]);

  @HostBinding('class.fileover') fileOver = false;

  fileDropped = output<FileList>();

  @HostListener('dragover', ['$event'])
  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.fileOver = true;
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.fileOver = false;
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.fileOver = false;
    const files = event.dataTransfer?.files;
    if (!files || files.length === 0) return;

    const allowed = this.allowedTypes();
    if (allowed.length > 0) {
      const validFiles = Array.from(files).filter(f => this.isTypeAllowed(f, allowed));
      if (validFiles.length === 0) {
        this.#snackbar.show({ message: 'Unsupported file format' });
        return;
      }
      const dt = new DataTransfer();
      validFiles.forEach(f => dt.items.add(f));
      this.fileDropped.emit(dt.files);
    } else {
      this.fileDropped.emit(files);
    }
  }

  private isTypeAllowed(file: File, allowed: string[]): boolean {
    const fileType = file.type;
    if (fileType) {
      return allowed.some(type => {
        if (type.endsWith('/*')) {
          return fileType.startsWith(type.replace('/*', '/'));
        }
        return fileType === type;
      });
    }
    // Fallback: check extension when MIME is empty
    const ext = file.name.split('.').pop()?.toLowerCase() || '';
    const extMap: Record<string, string> = {
      mp4: 'video', mov: 'video', webm: 'video', avi: 'video',
      jpg: 'image', jpeg: 'image', png: 'image', gif: 'image', webp: 'image',
    };
    const category = extMap[ext];
    return !!category && allowed.some(t => t === `${category}/*` || t === `${category}/${ext}`);
  }
}
